// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"UsefullLinks__Wrapper_1Er_U","Title":"UsefullLinks__Title_3LvsI","Links":"UsefullLinks__Links_weTHT grid","LinkWrapper":"UsefullLinks__LinkWrapper_daQJq"};